import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";
import { companyUrl } from "views_shared/app/javascript/utils/urls";

function CompanyProfileCard({ imageUrl = null, slug = null, migrateId = null, name = null, isLoading = false }) {
  const skeleton = () => (
    <div className="d-flex">
      <Skeleton circle width="3.125rem" height="3.125rem" />
      <Skeleton width="8em" className="ms-2" containerClassName="mt-3" />
    </div>
  );

  if (isLoading) return skeleton();
  if (name === null) return null;

  return (
    <div>
      <ImageCropped roundedCircle wrapperClasses="me-1" src={imageUrl} alt={name} size={50} fallbackToInitials />
      <a href={companyUrl({ slug, migrate_id: migrateId })} className="ms-2 text-decoration-underline">
        {name}
      </a>
    </div>
  );
}

CompanyProfileCard.propTypes = {
  imageUrl: PropTypes.string,
  slug: PropTypes.string,
  migrateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default CompanyProfileCard;
